import parseHtml from 'html-react-parser';
import { MDSPanel, MDSPanelBody, MDSPanelHeader, MDSTypography } from '@marqvision/mds/core';
import { useBreakpoint } from '~/hooks';
import privacy from './privacy.html';
import terms from './terms.html';

interface IProps {
  type: 'terms' | 'privacy' | null;
  onClose: () => void;
}

const Policy = {
  terms: {
    title: 'Terms and Conditions',
    file: terms,
  },
  privacy: {
    title: 'Privacy Policy',
    file: privacy,
  },
};

const PolicyPanel = ({ type, onClose }: IProps): JSX.Element => {
  const { getMediaQueryValue: mq } = useBreakpoint();

  return (
    <MDSPanel
      open={!!type}
      onClose={onClose}
      anchor="right"
      width={mq('100%', '100%', '960px')}
      BackdropProps={{ invisible: true }}
      style={{ maxWidth: '960px', zIndex: 1302 }}
    >
      <MDSPanelHeader title={type ? Policy[type]!.title : ''} onClose={onClose} style={{ boxSizing: 'border-box' }} />
      <MDSPanelBody
        style={{
          boxSizing: 'border-box',
          paddingLeft: mq('24px', '40px', '40px'),
          paddingRight: mq('24px', '40px', '40px'),
          height: '100%',
        }}
      >
        <MDSTypography variant={mq('T14', 'T16', 'T16')} weight="regular" style={{ marginTop: '40px' }}>
          {parseHtml(type ? Policy[type]!.file : '')}
        </MDSTypography>
      </MDSPanelBody>
    </MDSPanel>
  );
};

export default PolicyPanel;
